
























import { Component, Vue, Prop } from "vue-property-decorator";
import TableComponent from "@/components/table/TableComponent.vue";

import BatteryTag from "@/basics/icon/BatteryTag.vue";

interface Room {
  token: string;
  name: string;
  number: string;
  isUsed: boolean;
}

@Component({
  components: {
    TableComponent,
    BatteryTag
  }
})
export default class RoomTableBattery extends Vue {
  @Prop({ type: String, required: true }) title!: string[];
  @Prop({ type: Array, required: true }) rooms!: Room[];
}
